import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import { FaStar, FaDownload, FaApple, FaAndroid } from 'react-icons/fa';
import posthog from 'posthog-js';
import { trackMetaInstallLead } from '../../utils/metaPixel';
import classNotes from "./images/sc1.png";
import sc2 from "./images/sc2.png";
import sc3 from "./images/sc3.png";
import sc4 from "./images/sc4.png";
import sc5 from "./images/sc5.png";
import sc6 from "./images/sc6.png";
import sc7 from "./images/sc7.png";
import sc8 from "./images/sc8.png";
import sc9 from "./images/sc9.png";
import sc10 from "./images/sc10.png";

import landing_calendar_2 from "./images/landingImage.png";
import Modal from "react-bootstrap/Modal";
import Header from "./Header";
import SiteCtaAndFooter from "./SiteCtaAndFooter";
import styles from './css/css/style.module.css';
import './css/customs/landingPage.css';



const reviews = [
  {
    id: '1',
    name: 'Jannatul Ferdaus Trisha',
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjUZ9WZ8ReK64zlBZkMnKd0zPq61rSA5Ckri7gBc1LBfRwcLDU5eaA',
    rating: 5,
    review: 'great great great initiative. i was looking for a app like this.which is close to Duolingo so i can learn arabic(Quran). i dont know how to thank you people..much recommended..everyone should try.',
  },
  {
    id: '2',
    name: 'Khaled Quayyum',
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjW4yuAGeSX2e-oyz1IKHEPFllueLIn9_IsYliohW9uPhogxRuxr',
    rating: 5,
    review: 'Nice way to learn 👌 arabic',
  },
  {
    id: '3',
    name: 'Dr.Monir Khan',
    image: 'https://randomuser.me/api/portraits/men/30.jpg',
    rating: 4,
    review: 'Love this AI. May Allah grant them jannatul firdous',
  },
  {
    id: '4',
    name: 'Jerin Hadika Kingshu',
    image: 'https://lh3.googleusercontent.com/a/ACg8ocKJXUG-N9Uz7OlbiJMsLRmHKG9Rudp78mrqUYL_SLFWaip45g=mo',
    rating: 5,
    review: 'Finally found an app like this. thanks for creating this app',
  },
  {
    id: '5',
    name: 'ありや。',
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjWBgQX2-lg9b5iuDqf0WG-LUTvRvyyA7dbyZoIW4FytEMxFFwll',
    rating: 5,
    review: 'Alhamdulillah, very good. easy to use interface, great for revising and practicing as much as I want. keep up the good work.',
  },
  {
    id: '6',
    name: 'Rabia Hamid',
    image: 'https://lh3.googleusercontent.com/a/ACg8ocISuo_mnYFa3NYBKtuNxpMOTs_8rXyTqwCaHh49lziGxiG1fA=mo',
    rating: 5,
    review: 'Amazing very interesting and educational way to learn quran',
  },
  {
    id: '7',
    name: 'Rafat Manowar',
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjV0KO0OJ5bMhLVV8O9btUkSzkimHDgfh9iSApJVd6Jqve7X29A',
    rating: 5,
    review: 'Ma Sha Allah. I am loving it.',
  },
  {
    id: '8',
    name: 'Hina Javaid',
    image: 'https://lh3.googleusercontent.com/a/ACg8ocIu4D2TY0XvO1QJ2Bpnln5_zDf2pMYMS2EOW11bTw1zrC-deg=mo',
    rating: 5,
    review: 'Such an incredible app. Simple and easy to use. Keep it up',
  },
  {
    id: '9',
    name: 'Jenan Rabby',
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjVioRBijGKRMuaUd4M2mMY4n6SqgAf16CpNxcNBX0kUKH8paimJ',
    rating: 5,
    review: 'Very nice app to practice Quranic vocabulary and boost up confidence.',
  },
  {
    id: '10',
    name: 'Maksuda Islam Lima',
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjVR0R42oNonJCYIir2oCGzAJlgFH7XEhwOxUg1JwL_-OkyD7VYkoQ',
    rating: 5,
    review: 'Good experience!',
  },
];

function LandingPage(props) {
  const [show, setShow] = React.useState(false);
  const [isVisible, setIsVisible] = React.useState(false);
  const [reviewIndex, setReviewIndex] = useState(0);
  const trackingRef = useRef({});

  useEffect(() => {
    // Add fade-in effect when component mounts
    setTimeout(() => {
      setIsVisible(true);
    }, 300);

    // Add scroll event listener for animations
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const isInView = rect.top <= window.innerHeight * 0.8;
        if (isInView) {
          el.classList.add('visible');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function handleShow() {
    setShow(true);
  }
  function handleClose() {
    setShow(false);
  }

  const trackDownloadClick = (platform) => {
    // Use a timestamp-based key to prevent double-tracking within 1 second
    const key = `${platform}-${Math.floor(Date.now() / 1000)}`;
    if (trackingRef.current[key]) return;
    trackingRef.current[key] = true;
    
    // Clean up old keys after 2 seconds
    setTimeout(() => {
      delete trackingRef.current[key];
    }, 2000);

    // Capture event with device type
    posthog.capture('download_button_clicked', {
      platform: platform,
      timestamp: new Date().toISOString(),
      page: 'landing_page',
      device_type: /Mobile|Android|iPhone|iPad/.test(navigator.userAgent) ? 'mobile' : 'desktop'
    });

    trackMetaInstallLead(platform);
    
    // Force immediate flush to ensure event is sent before navigation
    if (posthog && typeof posthog.flush === 'function') {
      posthog.flush();
    }
  };

  // Handler that works for both mouse and touch events
  const handleDownloadInteraction = (platform, e) => {
    trackDownloadClick(platform);
  };

  const trackButtonClick = (buttonName) => {
    posthog.capture('button_clicked', {
      button_name: buttonName,
      timestamp: new Date().toISOString(),
      page: 'landing_page'
    });
  };
  return (
    <>
      <Helmet>
        <title>Qurania – Learn Quranic Arabic & Memorize the Quran Easily</title>
        <meta name="description" content="Qurania helps you understand and memorize the Quran in Arabic using simple stories, AI tutors, and 5-minute daily lessons. Learn Quranic vocabulary, memorize Quran faster without grammar overload." />
        <meta name="keywords" content="learn quranic arabic, understand quran, how to memorize quran, memorize quran, quranic vocabulary, learn arabic, quran app, quranic learning, AI quran tutor, understand quran in arabic, memorize quran fast, quran memorization app" />
        <meta property="og:title" content="Qurania – Learn Quranic Arabic & Memorize the Quran" />
        <meta property="og:description" content="Master Quranic Arabic and memorize the Quran through engaging stories and AI guidance. 5-minute daily lessons for busy Muslims." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Qurania – Learn Quranic Arabic & Memorize the Quran" />
        <meta name="twitter:description" content="Learn and memorize Quranic Arabic through stories, AI tutors, and daily habits." />
        <meta property="og:image" content="https://www.quranstories.pro/logo512.png" />
        <meta name="twitter:image" content="https://www.quranstories.pro/logo512.png" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            { "@type": "Question", "name": "Do I need to know Arabic to use Qurania?", "acceptedAnswer": { "@type": "Answer", "text": "No. Qurania is designed for complete beginners and non-Arabic speakers. You'll start from the basics and progress at your own pace." } },
            { "@type": "Question", "name": "Is Qurania focused on grammar?", "acceptedAnswer": { "@type": "Answer", "text": "No. Qurania focuses on understanding Quranic vocabulary and meaning first, without heavy grammar. Grammar comes naturally as you learn through stories." } },
            { "@type": "Question", "name": "How is Qurania different from other Quran apps?", "acceptedAnswer": { "@type": "Answer", "text": "Most apps focus on recitation or memorization. Qurania focuses on understanding the Quran by teaching the most common Arabic words through stories and AI guidance." } },
            { "@type": "Question", "name": "How long does it take to see results?", "acceptedAnswer": { "@type": "Answer", "text": "Many users start recognizing Quranic words within the first few weeks of consistent daily use. Understanding deepens over time with regular practice." } },
            { "@type": "Question", "name": "Can I use Qurania offline?", "acceptedAnswer": { "@type": "Answer", "text": "Qurania works best with an internet connection for AI-powered features." } },
            { "@type": "Question", "name": "Is there a free trial or free version?", "acceptedAnswer": { "@type": "Answer", "text": "Yes! Qurania offers a free version with access to core features. You can start learning immediately without any payment. Premium features are available for users who want advanced AI tutoring." } }
          ]
        })}</script>
      </Helmet>
      <Header />
      
      <div id="hero-section" className={`hero-section ${isVisible ? 'visible' : ''}`}>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">Understand the Quran in Arabic — One Story at a Time</h1>
              <p className="hero-subtitle">Qurania helps busy Muslims learn Quranic Arabic using simple stories, common vocabulary, and AI guidance — just 5 minutes a day.</p>
              
              <ul className="hero-benefits">
                <li>Learn most frequent Quranic words</li>
                <li>No grammar stress, no memorization pressure</li>
                <li>Story-based learning inspired by the Quran</li>
                <li>Built for beginners and non-Arabic speakers</li>
              </ul>
              
              <div className="cta-buttons">
                <a 
                  href="https://play.google.com/store/apps/details?id=com.neuralworks.quran75" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="download-btn download-btn-android"
                  onMouseDown={(e) => handleDownloadInteraction('Android', e)}
                  onTouchStart={(e) => handleDownloadInteraction('Android', e)}
                  onClick={(e) => handleDownloadInteraction('Android', e)}
                >
                  <FaAndroid className="btn-icon" />
                  <div className="btn-content">
                    <span className="btn-label">Download for</span>
                    <span className="btn-platform">Android</span>
                  </div>
                  <FaDownload className="btn-download-icon" />
                </a>
                <a 
                  href="https://apps.apple.com/us/app/qurania-learn-quran-with-ai/id6749280274?platform=iphone" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="download-btn download-btn-ios"
                  onMouseDown={(e) => handleDownloadInteraction('iPhone', e)}
                  onTouchStart={(e) => handleDownloadInteraction('iPhone', e)}
                  onClick={(e) => handleDownloadInteraction('iPhone', e)}
                >
                  <FaApple className="btn-icon" />
                  <div className="btn-content">
                    <span className="btn-label">Download for</span>
                    <span className="btn-platform">iPhone</span>
                  </div>
                  <FaDownload className="btn-download-icon" />
                </a>
              </div>
              
              {/* <div className="scroll-indicator">
                <FaArrowDown className="bounce" />
                <span>Discover More</span>
              </div> */}
            </div>
            
            <div className="hero-image">
              <img
                src={sc5}
                alt="Qurania App - Learn Quranic Arabic"
                className="app-screenshot"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="info-section animate-on-scroll">
        <div className="container">
          <div className="info-grid">
            <div className="info-card">
              <h2>What Is Qurania?</h2>
              <p>Qurania is an AI-powered app designed to help you understand and memorize the Quran in its original Arabic language. Instead of overwhelming grammar rules, Qurania teaches Quranic Arabic through short, emotionally engaging stories and high-frequency words found throughout the Quran.</p>
              <p>Whether you are a beginner or someone who reads the Quran daily but does not understand it, Qurania makes learning and memorizing Arabic simple, meaningful, and consistent.</p>
            </div>
            
            <div className="info-card">
              <h2>Who Is Qurania For?</h2>
              <ul className="info-list">
                <li>Muslims who want to understand the Quran, not just recite it</li>
                <li>Busy professionals with limited daily time</li>
                <li>Beginners with no Arabic background</li>
                <li>Learners who feel stuck memorizing without understanding</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="features-section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">How Does Qurania Help You Understand the Quran?</h2>
            <div className="section-divider"></div>
            <p className="section-description">
              By focusing on the most repeated words in the Quran, Qurania helps you recognize meanings naturally during recitation and prayer.
            </p>
          </div>
          
          <div className="how-it-works-list">
            <div className="how-step">
              <span className="step-number">1</span>
              <h3>Learn high-frequency Quranic vocabulary</h3>
              <p>Master the most common words you'll encounter in the Quran</p>
            </div>
            <div className="how-step">
              <span className="step-number">2</span>
              <h3>See words used inside short Quran-inspired stories</h3>
              <p>Understand words in context, not isolation</p>
            </div>
            <div className="how-step">
              <span className="step-number">3</span>
              <h3>Practice with an AI tutor that explains gently</h3>
              <p>Get personalized guidance without judgment</p>
            </div>
            <div className="how-step">
              <span className="step-number">4</span>
              <h3>Build a daily habit with 5-minute lessons</h3>
              <p>Consistency matters more than intensity</p>
            </div>
          </div>
          
          <div className="device-showcase">
            <div className="animate-on-scroll" style={{transitionDelay: '0.1s'}}>
              <div className="app-screenshot-container">
                <img
                  src={sc3}
                  alt="Story organized in Episodes!"
                  loading="lazy"
                />
              </div>
              
            </div>

            <div className="animate-on-scroll" style={{transitionDelay: '0.3s'}}>
              <div className="app-screenshot-container">
                <img
                  src={sc4}
                  alt="Listen to the recitation to immerse yourself in learning!"
                  loading="lazy"
                />
              </div>
            </div>

            
          </div>
        </div>
      </div>

      <div id="features-section" className="features-section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Engaging Quranic <span className="gradient-text"> Story</span> Based Learning</h2>
            <div className="section-divider"></div>
            <p className="section-description">
              Discover Quranic words within engaging Quranic stories. Understand word meanings in context, making memorization easier and Quran exploration fascinating. Qurania guides you through the Quranic stories with ease to learn the most frequently used Quranic words. So you can learn Quranic Arabic super fast.
            </p>
          </div>

          <div className="device-showcase">
            <div className="animate-on-scroll" style={{transitionDelay: '0.1s'}}>
              <div className="app-screenshot-container">
                <img
                  src={classNotes}
                  alt="Quranic Stories Chapters"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="animate-on-scroll" style={{transitionDelay: '0.1s'}}>
              <div className="app-screenshot-container">
                <img
                  src={sc2}
                  alt="Quranic Stories Chapters"
                  loading="lazy"
                />
              </div>
              
            </div>
            

          </div>
        </div>
      </div>
      



      <div id="activities-section" className="activities-section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Fun <span className="gradient-text">Gamified</span> learning Activities!</h2>
            <div className="section-divider"></div>
            <p className="section-description">
              Enjoy quizzes, word games, and spaced repetition techniques. Have fun while reinforcing your learning and remembering what you've studied. Solve Quizzes to test your knowledge and earn rewards. Progress through levels, collect badges, earn streaks, and unlock new features to keep learning and motivated.
            </p>
          </div>

          <div className="device-showcase">
            <div className="animate-on-scroll" style={{transitionDelay: '0.1s'}}>
              <div className="app-screenshot-container">
                <img
                  src={sc5}
                  alt="Take Quiz to Test your Learning"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="animate-on-scroll" style={{transitionDelay: '0.3s'}}>
              <div className="app-screenshot-container">
                <img
                  src={sc6}
                  alt="Gamified Way of Memorization"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="activities-section" className="activities-section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title"><span className="gradient-text">Dark</span> Mode & <span className="gradient-text">Multi</span> Language Support</h2>
            <div className="section-divider"></div>
            <p className="section-description">
              Choose your preferred theme and language to make learning more comfortable and enjoyable. Set daily reminders to keep you on track and motivated.
            </p>
          </div>

          <div className="device-showcase">
            <div className="animate-on-scroll" style={{transitionDelay: '0.1s'}}>
              <div className="app-screenshot-container">
                <img
                  src={sc7}
                  alt="Take Quiz to Test your Learning"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="animate-on-scroll" style={{transitionDelay: '0.3s'}}>
              <div className="app-screenshot-container">
                <img
                  src={sc8}
                  alt="Gamified Way of Memorization"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="story-learning-section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Learn Quranic Arabic Through <span className="gradient-text">Stories?</span></h2>
            <div className="section-divider"></div>
          </div>
          <div className="story-content">
            <p>Stories activate memory, emotion, and understanding — making learning faster and more natural. Qurania uses simple, Quran-inspired stories so words are learned in context, not isolation.</p>
            <p>This approach is ideal for learners who have tried traditional Arabic courses but struggled to stay consistent.</p>
          </div>
        </div>
      </div>

      <div className="daily-habit-section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Memorize & Learn Quranic Arabic in Just <span className="gradient-text">5 Minutes a Day</span></h2>
            <div className="section-divider"></div>
          </div>
          <div className="habit-content">
            <p>Consistency matters more than intensity. Qurania is designed for short daily sessions that fit into your life — before work, after prayer, or before sleep.</p>
            <p><strong>Small daily progress leads to real understanding and memorization of the Quran over time.</strong></p>
          </div>
        </div>
      </div>

      <div className="faq-section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Frequently Asked <span className="gradient-text">Questions</span></h2>
            <div className="section-divider"></div>
          </div>
          
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Do I need to know Arabic to use Qurania?</h3>
              <p>No. Qurania is designed for complete beginners and non-Arabic speakers. You'll start from the basics and progress at your own pace.</p>
            </div>
            
            <div className="faq-item">
              <h3>Is Qurania focused on grammar?</h3>
              <p>No. Qurania focuses on understanding Quranic vocabulary and meaning first, without heavy grammar. Grammar comes naturally as you learn through stories.</p>
            </div>
            
            <div className="faq-item">
              <h3>How is Qurania different from other Quran apps?</h3>
              <p>Most apps focus on recitation or memorization. Qurania focuses on understanding the Quran by teaching the most common Arabic words through stories and AI guidance.</p>
            </div>
            
            <div className="faq-item">
              <h3>How long does it take to see results?</h3>
              <p>Many users start recognizing Quranic words within the first few weeks of consistent daily use. Understanding deepens over time with regular practice.</p>
            </div>
            
            <div className="faq-item">
              <h3>Can I use Qurania offline?</h3>
              <p>Qurania works best with an internet connection for AI-powered features. </p>
            </div>
            
            <div className="faq-item">
              <h3>Is there a free trial or free version?</h3>
              <p>Yes! Qurania offers a free version with access to core features. You can start learning immediately without any payment. Premium features are available for users who want advanced AI tutoring.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="reviews-section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">What Our Users <span className="gradient-text">Say</span></h2>
            <div className="section-divider"></div>
            <p className="section-description">
              Join thousands of Muslims learning Quranic Arabic with Qurania
            </p>
          </div>
          
          <div className="reviews-carousel">
            <div className="reviews-grid">
              {reviews.map((review) => (
                <div key={review.id} className="review-card">
                  <div className="review-header">
                    <div className="reviewer-image-wrapper">
                      <img 
                        src={review.image} 
                        alt={review.name} 
                        className="reviewer-image"
                        loading="lazy"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextElementSibling.style.display = 'flex';
                        }}
                      />
                      <div className="reviewer-avatar-fallback">
                        {review.name.charAt(0).toUpperCase()}
                      </div>
                    </div>
                    <div className="reviewer-info">
                      <h4>{review.name}</h4>
                      <div className="star-rating">
                        {[...Array(5)].map((_, i) => (
                          <FaStar
                            key={i}
                            className={i < review.rating ? 'star-filled' : 'star-empty'}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="review-text">{review.review}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div id="activities-section" className="activities-section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Select from <span className="gradient-text">AI Tutors</span> & Start Quranic Journey!</h2>
            <div className="section-divider"></div>
            <p className="section-description">
              Choose from our AI tutors based on your learning style and gender to get personalized learning experiences. Our AI tutors are trained on a large corpus of Quranic Arabic text, and they can generate personalized learning experiences based on the user's learning style and preferences.
            </p>
          </div>

          <div className="device-showcase">
            <div className="animate-on-scroll" style={{transitionDelay: '0.1s'}}>
              <div className="app-screenshot-container">
                <img
                  src={sc9}
                  alt="Take Quiz to Test your Learning"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="animate-on-scroll" style={{transitionDelay: '0.3s'}}>
              <div className="app-screenshot-container">
                <img
                  src={sc10}
                  alt="Gamified Way of Memorization"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <SiteCtaAndFooter downloadTrackingPage="landing_page" />
    </>
  );
}

export default LandingPage;
